// Test utility to verify the chat API is working
export const testChatAPI = async () => {
  const baseUrl = 'https://api.swarmind.ai';
  const apiKey = '62BmqYsQ4u9j03BIiEsnloWXJd_o3UV5UoPZJnXrtNJPvUUmi3y9xVVql4boEyaQJf8Y4FxA5Wp7ArPrVC5FUw==';
  
  console.log('🧪 Testing Chat API...');
  
  try {
    const response = await fetch(`${baseUrl}/lai/testing/v1/chat/completions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiKey}`,
      },
      body: JSON.stringify({
        model: 'tiger-gemma-9b-v1-i1',
        messages: [
          { role: 'user', content: 'Hello! Can you hear me?' }
        ],
        stream: false,
      }),
    });

    console.log('📡 Response status:', response.status);
    console.log('📡 Response headers:', Object.fromEntries(response.headers.entries()));

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ API Error:', response.status, response.statusText);
      console.error('❌ Error details:', errorText);
      return false;
    }

    const data = await response.json();
    console.log('✅ API Response:', data);
    return true;

  } catch (error) {
    console.error('❌ Network Error:', error);
    return false;
  }
};

// Test streaming API
export const testStreamingChatAPI = async () => {
  const baseUrl = 'https://api.swarmind.ai';
  const apiKey = '62BmqYsQ4u9j03BIiEsnloWXJd_o3UV5UoPZJnXrtNJPvUUmi3y9xVVql4boEyaQJf8Y4FxA5Wp7ArPrVC5FUw==';
  
  console.log('🧪 Testing Streaming Chat API...');
  
  try {
    const response = await fetch(`${baseUrl}/lai/testing/v1/chat/completions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiKey}`,
      },
      body: JSON.stringify({
        model: 'tiger-gemma-9b-v1-i1',
        messages: [
          { role: 'user', content: 'Hello! Please respond with a short greeting.' }
        ],
        stream: true,
      }),
    });

    console.log('📡 Streaming response status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Streaming API Error:', response.status, response.statusText);
      console.error('❌ Error details:', errorText);
      return false;
    }

    const reader = response.body?.getReader();
    if (!reader) {
      console.error('❌ No readable stream');
      return false;
    }

    const decoder = new TextDecoder();
    let buffer = '';
    let chunkCount = 0;

    try {
      while (true) {
        const { done, value } = await reader.read();
        
        if (done) {
          console.log('✅ Stream completed');
          break;
        }

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          const trimmedLine = line.trim();
          
          if (trimmedLine === '') continue;
          if (trimmedLine === 'data: [DONE]') {
            console.log('✅ Stream finished with [DONE]');
            return true;
          }

          if (trimmedLine.startsWith('data: ')) {
            try {
              const jsonStr = trimmedLine.slice(6);
              const chunk = JSON.parse(jsonStr);
              chunkCount++;
              console.log(`📦 Chunk ${chunkCount}:`, chunk);
              
              if (chunk.choices?.[0]?.delta?.content) {
                console.log('💬 Content:', chunk.choices[0].delta.content);
              }
            } catch (error) {
              console.warn('⚠️ Failed to parse chunk:', trimmedLine);
            }
          }
        }
      }
    } finally {
      reader.releaseLock();
    }

    return true;

  } catch (error) {
    console.error('❌ Streaming Network Error:', error);
    return false;
  }
};

// Test available models using the new models service
export const testAvailableModels = async () => {
  console.log('🧪 Testing available models with models service...');
  
  try {
    // Test the models service
    const { modelsService } = await import('@/services/modelsService');
    const models = await modelsService.getAvailableModels();
    console.log('✅ Models service response:', models);
    
    // Also test the raw API endpoint
    const baseUrl = 'https://api.swarmind.ai';
    const apiKey = '62BmqYsQ4u9j03BIiEsnloWXJd_o3UV5UoPZJnXrtNJPvUUmi3y9xVVql4boEyaQJf8Y4FxA5Wp7ArPrVC5FUw==';
    
    console.log('🧪 Testing raw models API endpoint...');
    const response = await fetch(`${baseUrl}/models`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${apiKey}`,
      },
    });

    console.log('📡 Raw models response status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Raw Models API Error:', response.status, response.statusText);
      console.error('❌ Error details:', errorText);
    } else {
      const rawData = await response.json();
      console.log('✅ Raw models API response:', rawData);
    }
    
    return models;

  } catch (error) {
    console.error('❌ Models Service Error:', error);
    return false;
  }
};

// Add to window for easy testing in browser console
if (typeof window !== 'undefined') {
  (window as any).testChatAPI = testChatAPI;
  (window as any).testStreamingChatAPI = testStreamingChatAPI;
  (window as any).testAvailableModels = testAvailableModels;
}